import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const ImpressumPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen py-20"
      style={{ backgroundColor: 'var(--color-bg-primary)' }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-2 mb-10 transition-colors"
          style={{ color: 'var(--color-text-muted)' }}
        >
          <ArrowLeftIcon className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <h1 className="font-serif text-3xl md:text-4xl mb-2" style={{ color: 'var(--color-text-primary)' }}>
          Impressum
        </h1>
        <div className="section-divider" style={{ margin: '0.75rem 0 2.5rem 0' }} />

        <div className="space-y-10" style={{ color: 'var(--color-text-secondary)', lineHeight: 1.75 }}>

          {/* Angaben nach § 5 TMG */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Angaben gemäß § 5 TMG
            </h2>
            <p>
              Madlin Firme - malneudenken<br />
			  c/o Autorenglück #37737<br />
              Albert-Einstein-Straße 47<br />
              02977 Hoyerswerda
            </p>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Kontakt
            </h2>
            <p>
              Telefon: 0157 / 53557860<br />
              E-Mail:{' '}
              <a href="mailto:[E-MAIL]" style={{ color: 'var(--color-link-base)' }}>
                kontakt@malneudenken.de
              </a>
            </p>
          </section>

          {/* Berufsrechtliche Angaben */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Berufsrechtliche Angaben
            </h2>
            <p>
              Berufsbezeichnung: Systemische Beraterin<br />
              Verliehen in: Deutschland
            </p>
            <p className="mt-3">
              Mitglied im Berufsverband:<br />
              Systemische Gesellschaft – Deutscher Verband für systemische Forschung,
              Therapie, Supervision und Beratung e.V.<br />
              Damaschkestraße 4<br />
              D-10711 Berlin<br />
              <a
                href="https://www.systemische-gesellschaft.de"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--color-link-base)' }}
              >
                www.systemische-gesellschaft.de
              </a>
            </p>
          </section>

          {/* Kleinunternehmerregelung */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Umsatzsteuer
            </h2>
            <p>
              Gemäß § 19 UStG wird keine Umsatzsteuer berechnet
              (Kleinunternehmerregelung).
            </p>
          </section>

          {/* Streitschlichtung */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Streitschlichtung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--color-link-base)' }}
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-3">
              Ich bin nicht bereit und nicht verpflichtet, an
              Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          {/* Haftung für Inhalte */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werde ich
              diese Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Haftung für Links
            </h2>
            <p>
              Mein Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
            <p className="mt-3">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werde ich
              derartige Links umgehend entfernen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="font-serif text-xl mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Urheberrecht
            </h2>
            <p>
              Die durch mich erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
              Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb
              der Grenzen des Urheberrechts bedürfen meiner schriftlichen
              Zustimmung.
            </p>
            <p className="mt-3">
              Soweit die Inhalte auf dieser Seite nicht von mir erstellt wurden,
              werden die Urheberrechte Dritter beachtet. Insbesondere werden
              Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
              auf eine Urheberrechtsverletzung aufmerksam werden, bitte ich um
              einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werde ich derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </div>
    </motion.div>
  );
};

export default ImpressumPage;
